import { useQuery } from '@tanstack/react-query';
import { useRepository } from '@city-sage/aurum-avis-labs-components';
import { QueryKeys } from './QueryKeys';

export interface UseCommentsProps {
  postableType: 'itinerary' | 'stop';
  postableId: string;
}

export function useComments({ postableType, postableId }: UseCommentsProps) {
  const { api } = useRepository();

  // Fetch all posts (comments) for this postable entity
  const { data: comments = [], isLoading, error } = useQuery({
    queryKey: QueryKeys.post.byPostable(postableType.toUpperCase(), postableId),
    queryFn: () => api.findAllPost({ 
      filter: JSON.stringify({ 
        postableType: postableType.toUpperCase(), 
        postableId 
      }),
      // TODO this is hardcoded for now, we need to fix this
      limit: 1000
    }),
    enabled: !!postableId
  });

  return {
    comments,
    commentCount: comments.length,
    isLoading,
    error
  };
} 